// src/components/SEO.js
import { Helmet } from "react-helmet";
import logo from "../assests/logo-game.jpeg"

const SEO = ({ title, description, image }) => {
  const fullImage = image?.startsWith("http")
    ? image
    : `http://localhost:3000${image || logo}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
    </Helmet>
  );
};

export default SEO;
